import {ErrorBoundary} from '@sentry/react';

import {ReactNode} from 'react';

import {ErrorPage} from '@dms/shared';

type SentryErrorBoundaryProps = {
  children?: ReactNode;
};

export function SentryErrorBoundary({children}: SentryErrorBoundaryProps) {
  return <ErrorBoundary fallback={ErrorPage}>{children}</ErrorBoundary>;
}
